import api from './api';

// Marketplace Overrides — a partner, chain or hotel's own value for one marketplace setting.
// The entity is addressed the same way everywhere on the platform: the type string plus its id
// ('account' + ACCOUNTID, 'hotel' + hotelid, 'partner' + partnerid), so one service serves all three
// levels and a screen never has to know which endpoint to call.
const marketplaceOverrideService = {
    list:    (entityType, entityId) => api.get(`/marketplaceoverrides?entityType=${entityType}&entityId=${entityId}`),
    getById: (id)                   => api.get(`/marketplaceoverrides/${id}`),
    create:  (data)                 => api.post('/marketplaceoverrides', data),
    update:  (id, data)             => api.put(`/marketplaceoverrides/${id}`, data),
    remove:  (id)                   => api.delete(`/marketplaceoverrides/${id}`),
};

export default marketplaceOverrideService;
